import * as actionTypes from "../constants/actionTypes";
import * as config from "../constants/config";
import * as modelHelper from "../helpers/modelHelper";
import * as orderBy from "../constants/orderBy";

const initialState = {
    activeOrder: null,
    orderList: [],
    printData: null,
    tmcData: null,
    infoData: null,
    sortingCriterion: orderBy.CREATED,
    sortingAsc: false,
    filter: "",
    filterType: "all",
    offset: config.MAX_ORDERS_LIMIT
};

/**
 * Structure of object from toDispense store:
 * - activeOrder {Object}       - selected order from to dispense done order list
 * - orderList {Array}          - to dispense done order list,
 * - printData {Object}
 * - tmcData {Object}
 * - infoData {Object}
 * - sortingCriterion {String}
 * - sortingAsc {Boolean}
 */
export const ordersHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ORDERS_HISTORY_SAVE_ORDERS:
            if (action.payload.validOrder) {
                return {
                    ...state,
                    orderList: action.payload.orders
                };
            }

            return {
                ...state,
                activeOrder: null,
                printData: null,
                tmcData: null,
                infoData: null,
                orderList: action.payload.orders
            };
        case actionTypes.ORDERS_HISTORY_SAVE_ORDER_LIST_WITH_OFFSET:
            return {
                ...state,
                orderList: state.orderList.concat(action.payload.orders)
            };
        case actionTypes.ORDERS_HISTORY_CHANGE_OFFSET:
            return {
                ...state,
                offset: action.payload.offset
            };
        case actionTypes.ORDERS_HISTORY_SAVE_FILTER:
            return {
                ...state,
                filter: action.payload.filter
            };
        case actionTypes.ORDERS_HISTORY_SAVE_FILTER_TYPE:
            return {
                ...state,
                filterType: action.payload.filterType
            };
        case actionTypes.ORDERS_HISTORY_SAVE_PLAIN_ORDER_DETAIL:
            if (action.payload.order === null) {
                return {
                    ...state,
                    activeOrder: null,
                    printData: null,
                    tmcData: null,
                    infoData: null
                };
            }

            return {
                ...state,
                activeOrder: modelHelper.mapPlainOrderDataToObject(action.payload.order, action.payload.database),
                printData: modelHelper.formatPrintData(action.payload.printData),
                tmcData: action.payload.tmcData,
                infoData: action.payload.infoData
            };
        case actionTypes.ORDERS_HISTORY_SAVE_ORDER_DETAIL:
            if (action.payload.order === null) {
                return {
                    ...state,
                    activeOrder: null,
                    printData: null,
                    tmcData: null,
                    infoData: null
                };
            }

            let imageId = state.activeOrder && state.activeOrder.package ? state.activeOrder.package.imageId : -1;

            let order = modelHelper.mapOrderDataToObject(action.payload.order);

            return {
                ...state,
                activeOrder: order === null ? null : order.updateImageId(imageId),
                printData: modelHelper.formatPrintData(action.payload.printData),
                tmcData: action.payload.tmcData,
                infoData: action.payload.infoData
            };
        case actionTypes.ORDERS_HISTORY_SAVE_SORTING:
            return {
                ...state,
                sortingCriterion: action.payload.criterion,
                sortingAsc: action.payload.asc
            };
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return initialState;
        default:
            return state;
    }
};
